export const idOf = (item: any) => {
  if (item == null) return '';
  if (typeof item === 'string' || typeof item === 'number') return String(item);
  return String(item._id ?? item.id ?? '');
};

export const mergeById = (candidates: any[], extras: any[]) => {
  const merged = [...(candidates || [])];
  const seen = new Set(merged.map(idOf).filter(Boolean));
  for (const item of extras || []) {
    const id = idOf(item);
    if (id && !seen.has(id)) {
      seen.add(id);
      merged.push(item);
    }
  }
  return merged;
};
